import Card from "../../components/card";

export default function Students() {

  return (
    <>
    <main>
        <Card>
            <h3>My Excercises</h3>
        </Card>
    </main>
    </>
  );
}

